import { useI18n } from 'vue-i18n'
import { computed, type Ref } from 'vue'
import type { Plan } from '@/shared/types/api.types'

const DISCOUNT_NAME_LESS_1_PERCENT = 'qic.common.discounts-applied'
const DEFAULT_DISCOUNT_NAME = 'qic.common.discounts'
const SIGNLE_DISCOUNT_DEFAULT_NAME = 'qic.common.discount'
const calculateDiscountPercentage = (discount: number, price: number): number =>
  Math.round((discount / (price + discount)) * 100)

export const useDiscount = (
  currentScheme: Ref<{
    discounts: Plan['discounts']
    price: Plan['price']
  }>
) => {
  const { t } = useI18n()

  const discount = computed(() => {
    const price = currentScheme.value?.price
    const discounts = currentScheme.value?.discounts

    // @ts-ignore
    if (!discounts ?? !discounts?.length) {
      return {
        name: '',
        amount: 0,
        percentage: 0,
      }
    }

    if (discounts.length === 1) {
      const firstDiscount = discounts[0]
      const amount = Number(firstDiscount.premium)
      const percentage = calculateDiscountPercentage(amount, price)
      if (percentage >= 1) {
        return {
          name: firstDiscount.name ?? t(SIGNLE_DISCOUNT_DEFAULT_NAME),
          amount,
          percentage,
        }
      } else {
        return {
          name: t(DISCOUNT_NAME_LESS_1_PERCENT),
          amount,
          percentage: 0,
        }
      }
    }

    const amount = discounts.reduce((sum, discount) => sum + Number(discount.premium), 0)
    const percentage = calculateDiscountPercentage(amount, price)
    if (percentage >= 1) {
      console.log('name')
      return {
        name: t(DEFAULT_DISCOUNT_NAME),
        amount,
        percentage,
      }
    } else {
      return {
        name: t(DISCOUNT_NAME_LESS_1_PERCENT),
        amount,
        percentage: 0,
      }
    }
  })

  return { discount }
}
